// import React from "react";

// import styled from "styled-components/macro";
// import { ArrowLeft } from "react-feather";
// import { useBreakpoint } from "../../utilities/media-js-breakpoints";

// const ButtonContainer = styled.div`
//     ${({ theme }) => theme.bp.xs`
//         left: 10px;
//         top: 10px;
//     `};
//     ${({ theme }) => theme.bp.sm`
//         bottom: 25px;
//         top: auto;
//         left: 40px;
//     `};
//     position: absolute;
//     cursor: pointer;
//     color: white;
//     z-index: 3;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     font-size: 14px;
// `;

// const Text = styled.div`
//     padding: 0px 10px;
//     font-family: ${props => props.theme.fontFamily};
//     text-align: center;
//     filter: drop-shadow(1px 2px 4px rgba(0, 0, 0, 1));
// `;

// export const ButtonBack = ({ onClick }: { onClick: Function }) => {
//     const breakpoints = useBreakpoint();
//     return (
//         <ButtonContainer onClick={() => onClick()}>
//             <ArrowLeft
//                 style={{
//                     filter: "drop-shadow( 1px 2px 4px rgba(0, 0, 0, 1))",
//                 }}
//                 color="white"
//             />
//             {!breakpoints.sm ? <Text>TILLBAKA</Text> : null}
//         </ButtonContainer>
//     );
// };

import React, { useContext } from "react";
import { useSelector } from "react-redux";

import { get } from "lodash";
import styled, { ThemeContext } from "styled-components/macro";
import { ArrowLeft } from "react-feather";
import { useBreakpoint } from "../../utilities/media-js-breakpoints";
import { getAppConfig, getFrontendSettings, getLanguage } from "../../store/sagas/selectors";
import Constants from "../../constants";

const ButtonContainer = styled.div<ButtonContainerProps>`
    @media (min-width: 320px) and (max-width: 897px) and (orientation: portrait) {
        left: 10px;
        top: 10px;
        width: 35px;
        height: 35px;
        justify-content: center;
    }
    @media (min-width: 897px) {
        bottom: 25px;
        top: auto;
        left: 40px;
    }
    position: ${props => (props.isSticky ? "fixed" : "absolute")};
    cursor: pointer;
    color: white;
    z-index: 3;
    display: flex;
    flex-flow: column;
    align-items: center;
    font-size: 14px;
    ${({ theme }) => theme.bp.xxxl`
        transform: scale(1.85, 1.85);
        transform-origin: bottom left;
    `}
`;
const IconContainer = styled.div`
    ${({ theme }) =>
        theme.buttonBack.mode === "secondary"
            ? `background: rgba(255,255,255, 0.6); ${theme.buttonBack.backgroundColor};`
            : `background: ${theme.buttonBack.backgroundColor}; border: none;`}
    border-radius: 50%;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 3px 10px 0 rgba(0, 0, 0, 0.2);
    transition: background 0.2s ease-in-out;
    @media (hover) {
        &:hover {
            ${({ theme }) =>
                theme.buttonBack.mode === "secondary"
                    ? `background: rgba(255,255,255, 0.7);`
                    : `background: ${theme.buttonBack.hoverColor};`}
        }
        &:active {
            ${({ theme }) =>
                theme.buttonBack.mode === "secondary"
                    ? `background: rgba(255,255,255, 0.8);`
                    : `background: ${theme.buttonBack.activeColor};`}
        }
    }
`;

const Text = styled.div`
    font-family: ${props => props.theme.fontFamily};
    text-shadow: #000 0px 1px 12px;
    padding-top: 10px;
    text-align: center;
`;

interface ButtonContainerProps {
    isSticky?: boolean;
}

export const ButtonBack = ({ onClick, sticky, label }: { onClick: () => void; sticky?: boolean; label?: string }) => {
    const breakpoints = useBreakpoint();
    const theme = useContext(ThemeContext);
    const appConfig = useSelector(getAppConfig);
    const language = useSelector(getLanguage);
    const frontendSettings = useSelector(getFrontendSettings);

    const hideNavigationButtonsSetting = frontendSettings?.hide_navigation_buttons;
    const searchParams = new URLSearchParams(window.location.search);
    const param = searchParams.get(Constants.hideNavigationButtonsQueryParam);
    const hideNavigationButtons = param !== null ? JSON.parse(param) : hideNavigationButtonsSetting;

    if (hideNavigationButtons) {
        return null;
    }

    const buttonText = label ?? get(appConfig, `translations.${language}.back`);

    const renderDesktopButton = () => {
        return (
            <ButtonContainer isSticky={sticky} onClick={() => onClick()}>
                <IconContainer>
                    <ArrowLeft
                        color={theme.buttonBack.mode === "secondary" ? theme.buttonBack.backgroundColor : "white"}
                    />
                </IconContainer>
                <Text>{buttonText}</Text>
            </ButtonContainer>
        );
    };

    const renderMobileButton = () => {
        return (
            <ButtonContainer onClick={() => onClick()}>
                <ArrowLeft
                    style={{
                        filter: `drop-shadow( 1px 2px 4px #000)`,
                    }}
                    color="white"
                />
            </ButtonContainer>
        );
    };

    return !breakpoints.xxs && !breakpoints.xs && !breakpoints.sm ? renderDesktopButton() : renderMobileButton();
};
